import ViewModelCore from "./ViewModel";


export default class ProdutosClienteViewModel extends ViewModelCore{
    constructor () {
        super();
        this.Id = undefined;
        this.ClienteId = undefined;
        this.EmpresaId = undefined;
        this.ProdutoId = undefined;
        this.NomeEmpresa = undefined;
        this.Produto = undefined;
        this.Cliente = undefined;
        this.RazaoSocial = undefined;
        this.CodigoProduto = undefined;
        this.CodigoExterno = undefined;
        this.NumeroAltura = undefined;
        this.NumeroComprimento = undefined;
        this.NumeroLargura = undefined;
        this.NumeroAlturaTampa = undefined;
        this.CurvaClienteTexto = undefined;
        this.DataUltimoFaturamentoFormatada = undefined;
        this.DataUltimaVendaFormatada = undefined;
        this.ComponenteTipoTexto = undefined;
    }
}